import React from 'react'
import { clsx } from 'clsx'

export interface ResponsiveCardGridColumns {
  base?: 1
  sm?: 2 | 3
  xl?: 2 | 3 | 4
}

const DEFAULT_COLUMNS: Required<ResponsiveCardGridColumns> = { base: 1, sm: 2, xl: 3 }

const SM_CLASSES: Record<number, string> = {
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3'
}

const XL_CLASSES: Record<number, string> = {
  2: 'xl:grid-cols-2',
  3: 'xl:grid-cols-3',
  4: 'xl:grid-cols-4'
}

const GAP_CLASSES: Record<number, string> = {
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  6: 'gap-6',
  8: 'gap-8'
}

interface ResponsiveCardGridProps {
  children: React.ReactNode
  columns?: ResponsiveCardGridColumns
  gap?: number
  className?: string
}

export const ResponsiveCardGrid: React.FC<ResponsiveCardGridProps> = ({
  children,
  columns,
  gap = 4,
  className
}) => {
  const resolved = { ...DEFAULT_COLUMNS, ...columns }

  return (
    <div
      className={clsx(
        'grid grid-cols-1',
        SM_CLASSES[resolved.sm],
        XL_CLASSES[resolved.xl],
        GAP_CLASSES[gap] ?? GAP_CLASSES[4],
        className
      )}
    >
      {children}
    </div>
  )
}

export default ResponsiveCardGrid
